import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapMutations, mapActions, mapState } from 'vuex';
import { hasPermission } from '../template/auth.js';
import { previewMixin } from '../mixin/preview.js';

export default {
  mixins: [previewMixin],

  props: {
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    buttonAttrs: {
      type: Object
    },
    active: {
      type: [Number, String]
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },


  computed: _extends({}, mapState({
    groupsConfig: function groupsConfig(state) {
      return state.creative.template.groupsConfig || [];
    },
    permissionKeys: function permissionKeys(state) {
      return state.creative.template.permissions;
    }
  }), {
    innerButtonAttrs: function innerButtonAttrs() {
      return _extends({
        text: this.$t('playTurbo.custom.resourceDialog.handlerRelated.delete'),
        disabled: !this.isDeletable,
        style: 'width: 100%;'
      }, this.buttonAttrs);
    },


    // 基础包默认的、自带的都不可删除啊
    isDeletable: function isDeletable() {
      if (hasPermission({
        key: 'resource.basic-resource-deletable',
        permissionKeys: this.permissionKeys
      }) && this.resource.is_default !== 1) {
        return true;
      }
      return this.resource.is_default !== 1 && this.resource.is_basic !== 1;
    }
  }),

  methods: _extends({}, mapMutations({
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog',
    updatePreviewGroupConfig: 'creative/template/updatePreviewGroupConfig'
  }), mapActions({
    removeResource: 'creative/template/removeResource'
  }), {
    remove: function remove() {
      var _this = this;

      if (this.isDeletable === false) return;
      this.$emit('remove', this.resource);
      // 延迟清空当前 currentResource/currentCategory，因为移除前需要先找到 category 与 resource
      this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.removeResource(_this.resource);

              case 2:
                _this.updateCurrentResource(null);
                _this.updateCurrentCategory(null);
                _this.closeEditResourceDialog();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      })));
    }
  })
};